import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { DLModal } from 'appSrc/components/Shards';
import { dAPI } from 'appSrc/api';
import ProductForm from './ProductForm';
import LoadingOverlay from 'appSrc/components/Shards/Loading/Overlay';


class NewProductModal extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            fetching: false,
        };
    }
    submitHandler = ( { product, tags } ) => {
        this.setState( { fetching: true } );
        this.props.createProduct( { ...product } )
        .then((newProduct) => {
            this.setState( { fetching: false } );
            this.props.onSubmit && this.props.onSubmit( newProduct );
        });
        // this.props.createProduct( { ...product } )
        // .then( ( newProduct ) => {
        //     //handle adding tags
        //     var requests = [];
        //     for( var i = 0; i < tags.length; i++ ) {
        //         requests.push( this.props.addTag( newProduct.id, tags[ i ].tagtext ) );
        //     }
        //     return Promise.all( requests )
        //     .then( ( tagData ) => {
        //         newProduct.tags = tagData.map( ( eachTag ) => {
        //             return {
        //                 tagid: eachTag.tagid,
        //                 tagtext: eachTag.tagtext,
        //                 curated_products_tags: {
        //                     curated_product_id: newProduct.id,
        //                     tagid: eachTag.tagid,
        //                 },
        //             };
        //         } );
        //         return newProduct;
        //     } );
        // } )
        // .then( ( newProduct ) => {
        //     if( product.featured ) {
        //         this.props.updateProduct( newProduct.id, { featured: true, title: newProduct.title } )
        //         .then( ( newerProduct ) => {
        //             this.setState( { fetching: false } );
        //             this.props.onSubmit && this.props.onSubmit( newerProduct );
        //         } );
        //     } else {
        //         this.setState( { fetching: false } );
        //         this.props.onSubmit && this.props.onSubmit( newProduct );
        //     }
        // } );
    }



    render() {
        const initialValues = {};
        return (
            <DLModal title='New Product'
            closeHandler={ this.props.closeModal }>
                <div>
                    <ProductForm onSubmit={ this.submitHandler } initialValues={ initialValues } />
                </div>
                { this.state.fetching &&
                    <LoadingOverlay />
                }
            </DLModal>
        );
    }
}
const mapDispatchToProps = () => {
    return {
        createProduct: ( data ) => {
            return dAPI.post( '/admin/desires', data );
        },
        updateProduct: ( id, data ) => {
            return dAPI.patch( `/admin/desires/${ id }`, data );
        },
        addTagToProduct: ( desireid, newTag ) => {
            return dAPI.post( `/desires/${ desireid }/tag`, { tag: newTag } );
        },
        deleteTagFromProduct: ( desireid, tagtext ) => {
            return dAPI.delete( `/desires/${ desireid }/tag/${ tagtext }` );
        },
    };
};

export default connect( null, mapDispatchToProps )( NewProductModal );
